// Vanilla CSS for OrderingActivityMaterialContent. Prefix: mo2-
// Pixel-faithful port of the spv-ord-* design from the design-system V4 mock.tsx.
// Built on Playful Frost tokens — no Tailwind utility classes.
export const orderingActivityMaterialContentStyles = `
  /* ── container ───────────────────────────────────────────── */
  .mo2-root {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-family: var(--font-sans);
  }

  /* ── row ─────────────────────────────────────────────────── */
  .mo2-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: var(--rad-catchup-large);
    background: var(--catchup-white);
    border: 1.5px solid var(--catchup-blue-100);
    transition: border-color 150ms, background 150ms;
  }

  /* drag & drop reorder */
  .mo2-row[draggable="true"] { cursor: grab; }
  .mo2-row[draggable="true"]:active { cursor: grabbing; }
  .mo2-row.is-dragging { opacity: 0.45; }
  .mo2-row.is-dropover {
    border-color: var(--catchup-blue);
    box-shadow: 0 0 0 3px var(--brand-100, rgba(87,194,211,0.22));
  }
  .mo2-grip { flex-shrink: 0; display: flex; align-items: center; color: var(--catchup-blue-200); }
  .mo2-row:hover .mo2-grip { color: var(--catchup-blue); }

  /* correct-position reveal chip under a wrong row (shared aas-corr look) */
  .mo2-corr { margin-top: 6px; }

  /* graded recolor (V4 aas__order-row.is-correct/.is-wrong) */
  .mo2-row--correct {
    border-color: var(--color-success);
    background: linear-gradient(160deg, rgba(122,203,164,0.32), rgba(94,170,130,0.18));
    box-shadow: 0 0 0 3px var(--color-success-ring, rgba(70,150,95,0.22)), 0 8px 18px -10px rgba(46,125,85,0.5);
    color: var(--color-success-text);
  }
  .mo2-row--wrong {
    border-color: var(--color-error);
    background: var(--color-error-bg);
    box-shadow: 0 0 0 3px var(--color-error-ring, rgba(217,97,63,0.18));
    color: var(--color-error-text);
  }
  .mo2-row--correct .mo2-txt { color: var(--color-success-text); font-weight: 700; }
  .mo2-row--wrong .mo2-txt { color: var(--color-error-text); }

  /* graded ✓/✕ mark, right-aligned (V4 aas__mark) */
  .mo2-mark { margin-left: auto; flex-shrink: 0; font-weight: 800; font-size: var(--fs-lg); }
  .mo2-mark--ok { color: var(--color-success-text); }
  .mo2-mark--no { color: var(--color-error-text); }

  /* ── number bead ─────────────────────────────────────────── */
  .mo2-num {
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 50%;
    color: #fff;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--fs-sm);
    background: linear-gradient(160deg, var(--catchup-blue), var(--brand-dark));
    box-shadow:
      inset 0 1.5px 1.5px rgba(255,255,255,0.65),
      inset 0 -2px 3px rgba(15,72,89,0.3),
      0 4px 9px -3px rgba(87,194,211,0.6);
  }
  .mo2-row--correct .mo2-num {
    background: var(--catchup-white);
    border: 1.5px solid var(--accent-lime-text, var(--color-success-text));
    color: var(--accent-lime-text, var(--color-success-text));
    box-shadow: none;
  }
  .mo2-row--wrong .mo2-num {
    background: var(--catchup-white);
    border: 1.5px solid var(--accent-coral, var(--color-error));
    color: var(--accent-coral-text, var(--color-error-text));
    box-shadow: none;
  }

  /* ── text content ────────────────────────────────────────── */
  .mo2-txt {
    flex: 1;
    min-width: 0;
    font-size: var(--fs-base);
    font-weight: 600;
    color: var(--text-secondary);
  }

  /* math spans */
  .mo2-bold { font-weight: 800; }
  .mo2-underline { text-decoration: underline; }
  .mo2-xl { font-size: var(--fs-xl); }

  /* ── up/down buttons ─────────────────────────────────────── */
  .mo2-btns {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
  }
  .mo2-btn {
    width: 28px;
    height: 22px;
    cursor: pointer;
    border-radius: 7px;
    border: 1px solid var(--catchup-blue-100);
    background: var(--catchup-white);
    color: var(--brand-dark);
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 120ms, border-color 120ms;
  }
  .mo2-btn:disabled {
    opacity: 0.3;
    cursor: default;
  }
  .mo2-btn:not(:disabled):hover {
    background: var(--brand-50);
    border-color: var(--catchup-blue);
  }

  /* ── media option variant ────────────────────────────────── */
  .mo2-media-wrap {
    max-width: 100%;
    border-radius: var(--rad-catchup-medium);
    overflow: hidden;
  }

  /* ── responsive ──────────────────────────────────────────── */
  @media (max-width: 480px) {
    .mo2-row { padding: 10px 10px; gap: 8px; }
    .mo2-num { width: 26px; height: 26px; font-size: var(--fs-xs); }
    .mo2-btn { width: 26px; height: 20px; }
    .mo2-txt { font-size: var(--fs-sm); }
  }
`;
